import { useEffect, useState } from 'react'

const useScrollDown = () => {
    const [scrollValue, setScrollValue] = useState({ scrollX: window.scrollX, scrollY: window.scrollY });

    useEffect(() => {
        let ticking = false;
        const handleScroll = () => {
            if (!ticking) {
                window.requestAnimationFrame(() => {
                    setScrollValue({ scrollX: window.scrollX, scrollY: window.scrollY });
                    ticking = false;
                });
                ticking = true;
            }
        };

        window.addEventListener('scroll', handleScroll, { passive: true });
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    return scrollValue;
};

export default useScrollDown;